export default __webpack_public_path__ + "static/media/ic_place_24px.0c6de3b6.svg";